import React, { useEffect, useState } from 'react';

import { ARMOR_TYPES, ArmorType, CharacterSheetInterface } from "@dndModels";

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterArmorTrainingCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderArmorTrainingCustomization = (at: ArmorType) => {
    // debugger;
    const proficient = char.mind.armor_proficiencies.find(o => o.proficiency_id === at._id);
    return (
      <FlexBox key={at._id}>
        <FlexBox direction="row">
          <FlexBox xs_expand={0} style={{ width: "30%"}}>
            <FlexBox direction="column">
              <FlexBox>{ at.name }</FlexBox>
              { proficient && 
                <FlexBox className="small_label gray">Proficient</FlexBox>
              }
              { customizations.armor_training_overrides[at._id] !== undefined &&
                <FlexBox className="small_label gray">Overridden</FlexBox>
              }
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ customizations.armor_training_overrides[at._id] === undefined ? "Don't Override" : (customizations.armor_training_overrides[at._id] ? "true" : "false") } 
              options={[{ id: "true", text: "Proficient" }, { id: "false", text: "Not Proficient" }]}
              extra_options={["Don't Override"]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete customizations.armor_training_overrides[at._id];
                } else {
                  customizations.armor_training_overrides[at._id] = changed === "true";
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    );
  }

  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      { ARMOR_TYPES.map(dt => renderArmorTrainingCustomization(dt))}
    </FlexBox>
  );
}

